import chain from '@/lib/axios-chain'
// 获取普通表单详情
export const getUniversalFormDatas = () =>
  chain.create('/universal/form/content', 'get')
// 角色管理---开启关闭项目角色
export const changeRoleStatus = () =>
  chain.create('/user/invite/setroles', 'post')
// 角色管理---获取权限列表数据
export const getPermissionDatas = () =>
  chain.create('/user/permission/role-config', 'get')
// 角色管理---提交权限列表数据
export const updatePermissionDatas = () =>
  chain.create('/user/permission/role-update', 'post')

// 获取外部表单详情
export const getUniversalOutForm = () =>
  chain.create('/universal/form/content', 'get')
// 万能表单配置获取人员上级
export const getAllLeaderByUserid = () =>
  chain.create('/user/team/getallLeaderbyuserid', 'get')
// 万能表单配置获取通知人员数据
export const getAuthUsersListByPk = () =>
  chain.create('/user/team/getauthuserslistbypk', 'get')
// 万能表单配置保存
export const universalOutSave = () =>
  chain.create('/universal/form/save', 'post')
// 万能表单询盘详情差异
export const getFormatHistory = () =>
  chain.create('/apiform/getformathistory', 'get')
